module.exports = __webpack_public_path__ + "img/Frame 955t1.968c74a3.svg";